<script setup lang="ts">
import { useForwardPropsEmits } from "reka-ui";
import type { ClassProps } from "../../lib/base-props";
import FormField, { type FormFieldProps } from "../form/FormField.vue";
import { type SelectItem } from "./composables/select-items";
import type { SelectEmit } from "./Select.vue";
import SelectBuilder, { type SelectBuilderProps } from "./SelectBuilder.vue";

interface Props extends SelectBuilderProps<any, any>, FormFieldProps, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<SelectEmit<any, any>>();

const forwarded = useForwardPropsEmits(props, emit);

defineSlots<{
	prepend(): void;
	append(): void;
	selection(slotProps: { modelValue: any }): void;
	item(args: { item: SelectItem<any> }): void;
}>();
</script>

<template>
	<FormField :class="props.class" :label="props.label" :hint="props.hint" :errors="props.errors">
		<SelectBuilder class="w-full" v-bind="forwarded">
			<template #prepend>
				<slot name="prepend" />
			</template>

			<template #append>
				<slot name="append" />
			</template>

			<template #selection="slotProps">
				<slot name="selection" v-bind="slotProps" />
			</template>

			<template #item="slotProps">
				<slot name="item" v-bind="slotProps as any" />
			</template>
		</SelectBuilder>
	</FormField>
</template>
